import React from "react";
import Button from '../Utilities/Button';
import { ModalConfirm } from '../Utilities/Modal';
import { isIOS } from 'react-device-detect';

export default class List extends React.Component {
    state = {
        documents: {},
        confirmDelete: false,
        confirmDeleteSelection: false
    }

    docToDelete;

    async componentDidMount() {
        this.setState({
            documents: await window.sdk.session().getDocuments()
        })
    }

    select = (i) => {
        let documents = this.state.documents;
        documents[i].selected = documents[i].selected ? 0 : 1;

        this.setState({
            documents
        })
        this.isAllSelected()
    }

    selectAll = () => {
        let documents = this.state.documents;
        this.state.documents.map((i, key) => i.selected = 1)
        this.setState({
            documents,
            allSelect: true
        })

    }

    unSelectAll = () => {
        let documents = this.state.documents;
        this.state.documents.map((i, key) => i.selected = 0)
        this.setState({
            documents,
            allSelect: false
        })
    }

    isAllSelected = () => {
        this.setState({
            allSelect: this.state.documents.filter(i => i.selected != 1).length == 0
        })
    }

    toggleDeleteConfirm = (doc) => {
        this.setState({
            confirmDelete: !this.state.confirmDelete
        })
        this.docToDelete = doc;
    }

    toggleDeleteSectionConfirm = () => {
        this.setState({
            confirmDeleteSelection: !this.state.confirmDeleteSelection
        })
    }

    handleDelete = async () => {
        let res = await window.sdk.session().deleteDocument(this.docToDelete);
        this.setState({
            confirmDelete: false,
            documents: this.state.documents.filter(item => this.docToDelete.id != item.id)
        })
    }
    handleDeleteSelection = async () => {
        let docSelected = this.state.documents.filter(i => i.selected == 1);
        let documents = this.state.documents
        for (let i in docSelected) {
            await window.sdk.session().deleteDocument(docSelected[i]);
            documents = documents.filter(item => docSelected[i].id != item.id)
        }
        this.setState({
            confirmDeleteSelection: false,
            documents
        })
    }

    toggleDownloadSection = async () => {
        let docSelected = this.state.documents.filter(i => i.selected == 1);
        let res = await window.sdk.session().downloadDocuments(docSelected);
        let content = await res.blob();
        const url = URL.createObjectURL(content);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'archive_hocoia.zip');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
     }

    isPrintable(file){
        if(file.type.startsWith('image'))
            return true;
        return false;
    }

    close = () => {
        if(this.props.onClose)
            this.props.onClose()
        else
            window.sdk.event().emit('openHeaderModal',false);
    }

    onButtonClick = (file) => {
        // using Java Script method to get PDF file
        fetch('//' + window.sdk.getApiUrl() + file.path).then(response => {
            response.blob().then(blob => {
                // Creating new object of PDF file
                const fileURL = window.URL.createObjectURL(blob);
                // Setting various property values
                let alink = document.createElement('a');
                alink.href = fileURL;
                alink.download = file.name;
                alink.click();
            })
        })
    }

    onPrintClick = (file) => {
        // using Java Script method to get PDF file
        fetch('//' + window.sdk.getApiUrl() + file.path).then(response => {
            response.blob().then(blob => {
                // Creating new object of PDF file
                var frame = document.createElement('iframe');
                frame.onload = function() {
                  try {
                    this.contentWindow && this.contentWindow.print();
                    return;
                  } catch (e) {}
                  console.error('in a protective iframe?');
                };
                frame.src = URL.createObjectURL(blob);
                document.body.appendChild(frame);
            })
        })
    }

    onViewClick = (file) => {
        if(file.type.startsWith('image') || file.type.startsWith('video') || file.type.startsWith('audio'))
            window.sdk.lightboxMedia(file);
        else
            window.open('//' + window.sdk.getApiUrl() + file.path, '_blank');
    }

    showDate(d) {
        const date = new Date(d);
        const options = { hour: 'numeric', minute: 'numeric' };
        return date.toLocaleDateString('fr-FR', options).split(' ').pop();
    }

    render() {
        let docSelected;
        if (Object.keys(this.state.documents).length > 0)
            docSelected = this.state.documents.filter(i => i.selected == 1)

        return (
            <React.Fragment>
                <div className="documents">
                    <div className="documents__header">
                        <h2 className="documents__title">Fichiers patient</h2>
                        <p className="documents__subtitle">N'oubliez pas de télécharger vos fichiers patient avant de fermer la session car ils ne seront plus accessibles par la suite.</p>
                    </div>

                    {Object.keys(this.state.documents).length > 0 ?
                        <div className="documents__content">
                            <div className="documents__groupactions">
                                {this.state.allSelect == 1 ?
                                    <button className="button button--danger" onClick={this.unSelectAll}>
                                        Désélectionner tout
                                    </button>
                                    :
                                    <button className="button button--primary button--outline" onClick={this.selectAll}>
                                        Sélectionner tout
                                    </button>
                                }
                                {docSelected.length > 0 &&
                                    <React.Fragment>
                                    {!isIOS &&
                                    <button className="button button--primary button--download-all" onClick={this.toggleDownloadSection}>
                                        <i className="icon-download" />Télécharger la sélection
                                    </button> }
                                    <button className="button button--primary button--outline" onClick={this.toggleDeleteSectionConfirm}>
                                        <i className="icon-trash" />Supprimer la sélection
                                    </button>
                                    </React.Fragment>
                                }
                            </div>
                            <div className="documents__listwrapper">
                                <ul className="documents__list">
                                    {this.state.documents.map((i, key) =>
                                        <li className="documents__listitem" key={key}>
                                            <div className="listitem__cb listitem__cell">
                                                <input type="checkbox" id={'selected_doc' + key} onClick={() => this.select(key)} checked={i.selected} />
                                                <label for={'selected_doc' + key}></label>
                                            </div>
                                            <span className="listitem__icon listitem__cell">
                                                <i className={window.sdk.session().getFileIcon(i)}></i>
                                            </span>
                                            <div className="listitem__name listitem__cell" onClick={() => {this.onViewClick(i)}}><span>{i.clean_name} {this.showDate(i.date)} { i.duration > 0 ? '(' + i.duration + ' secondes)': '' }</span></div>                                        
                                            <div className="listitem__actions listitem__cell">
                                                <a className="listitem__action item__action--view" href="#" onClick={() => {this.onViewClick(i)}}>
                                                    <i className={"icon-view"} />
                                                </a>
                                                {this.isPrintable(i) ? <a className="listitem__action item__action--print" href="#" onClick={() => {this.onPrintClick(i)}} >
                                                    <i className={"icon-print"} />
                                                </a>
                                                :
                                                <a className="listitem__action item__action--empty"></a>
                                                }
                                                <a className="listitem__action item__action--download" onClick={() => {this.onButtonClick(i)}} >
                                                    <i className={"icon-download"} />
                                                </a>
                                                <a className="listitem__action item__action--delete" href="#" onClick={() => {this.toggleDeleteConfirm(i); return false; }}>
                                                    <i className={"icon-trash"}  />
                                                </a>
                                            </div>
                                        </li>
                                    )}
                                </ul>
                            </div>
                        </div>
                        :
                        <div className="documents__empty">Pas de document</div>
                    }
                    {this.state.confirmDelete && <ModalConfirm title={"Voulez vous supprimer le document ?"} onConfirm={(e) => { this.handleDelete() }} onCancel={this.toggleDeleteConfirm}></ModalConfirm>}
                    {this.state.confirmDeleteSelection && <ModalConfirm title={"Voulez vous supprimer ces documents ?"} onConfirm={(e) => { this.handleDeleteSelection() }} onCancel={this.toggleDeleteSectionConfirm}></ModalConfirm>}
                </div>
                <div className="modal__buttons">
                    <button className="button button--primary button--outline" onClick={() => this.close()}>{Object.keys(this.state.documents).length > 0 ? 'Annuler': 'Ok'}</button>
                </div>
            </React.Fragment >
        )
    }
}